import React from "react";
import PropTypes from "prop-types";

import Field from "features/application/field/component";

import "features/application/create-password/view.scss";

const CreatePasswordView = ({ formReference, sendApiRequest }) => (
  <form
    className="application__container"
    noValidate
    ref={formReference}
    onSubmit={sendApiRequest}
  >
    <h1 className="application__headline">Create new password</h1>
    <div className="authentication__container">
      <Field
        label="Create a password"
        name="password"
        type="password"
        maxLength={64}
        shouldValidate={true}
        rule="password"
        error="Password must be at least 8 characters long. The password must contain at least one lowercase character, one uppercase character and one digit."
      />
    </div>
    <input
      className="application__button"
      type="submit"
      value="Submit password"
    />
  </form>
);

CreatePasswordView.propTypes = {
  formReference: PropTypes.object,
  sendApiRequest: PropTypes.func,
};

export default CreatePasswordView;
